import { TagWorkerResult, TagWorkerType } from "@/ts/common-types";

export const processTagData = ({
    tagTypeList,
    recordType,
    validRecordTypes,
}: any): string[] => {
    const filteredTagTypes = tagTypeList.filter((tag: any) =>
        validRecordTypes.includes(tag.record_type.toLowerCase())
    );
    return [
        ...new Set(filteredTagTypes.flatMap((tagType: any) => tagType.tags_map)),
    ] as string[];
};

export const filterTags = ({ tags, inputValue }: any): string[] => {
    return tags.filter((tag: string) => {
        const tagValue = tag.split("##")[1] || tag;
        return inputValue.trim() === "" ||
            tagValue.toLowerCase().includes(inputValue.toLowerCase());
    });
};

// Worker handler
self.onmessage = (e: MessageEvent) => {
    try {
        const { type, payload } = e.data;

        switch (type) {
            case TagWorkerType.FILTER_TAGS:
                self.postMessage({
                    type: TagWorkerResult.FILTER_TAGS_RESULT,
                    payload: filterTags(payload),
                });
                break;
            case TagWorkerType.PROCESS_TAGS:
                self.postMessage({
                    type: TagWorkerResult.PROCESS_TAGS_RESULT,
                    payload: processTagData(payload),
                });
                break;
            default:
                console.warn("Unknown message type:", type);
        }
    } catch (error) {
        console.error("Worker error:", error);
        self.postMessage({
            type: "ERROR",
            payload: { error: (error as Error).message },
        });
    }
};
